<template>
    <div class="youtube youtube-block" ref="youtubeblock">
        <div v-if="error">
            <p>Youtube load error, try again later..</p>
            <!--TODO: Add more language specific error message-->
        </div>
        <PageMarketingConsent
            v-else-if="consent"
            @consent:acceptMarketing="acceptMarketing"
        />

        <div v-else>
            <div v-if="isLoading">
                <div class="loader"></div>
            </div>
            <div v-else>
                <div class="row">
                    <!-- Display video preview for active video -->
                    <div
                        :class="
                            horizontalPreview && hasManyVideos
                                ? 'col-md-7'
                                : 'col-xs-12'
                        "
                    >
                        <YoutubeVideoPreview
                            v-if="activeVideo"
                            :video="activeVideo"
                            :autoplay="autoplay"
                            :playlistTitle="playlistTitle"
                            :playlistUrl="playlistUrl"
                            :channel="channel"
                            :horizontalPreview="
                                horizontalPreview && !hasManyVideos
                            "
                            :simplePreview="simplePreview"
                            :texts="texts"
                        />
                    </div>

                    <!-- Display thumbnails for remaining playlist videos -->
                    <div
                        v-if="hasManyVideos"
                        :class="
                            horizontalPreview && hasManyVideos
                                ? 'col-md-5'
                                : 'col-xs-12'
                        "
                    >
                        <YoutubeVideoList
                            :videos="remainingVideos"
                            :texts="texts"
                            @playVideo="playVideo"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import { hasMarketingConsent } from '../Consent/consentUtil';
import YoutubeVideoPreview from './YoutubeVideoPreview';
import YoutubeVideoList from './YoutubeVideoList';
import PageMarketingConsent from '../Consent/PageMarketingConsent';
import filter from 'lodash/filter';

export default {
    name: 'YoutubePlaylistBlock',
    components: {
        YoutubeVideoPreview,
        YoutubeVideoList,
        PageMarketingConsent,
    },
    props: {
        blockId: { type: Number },
        horizontalPreview: { type: Boolean },
        simplePreview: { type: Boolean },
    },
    data() {
        return {
            isLoading: true,
            consent: false,
            error: false,
            playlistTitle: '',
            playlistUrl: '',
            videos: [],
            activeVideo: {},
            autoplay: false,
            channel: {},
            texts: {},
        };
    },
    computed: {
        remainingVideos() {
            // Playlist videos excluding activeVideo
            return filter(
                this.videos,
                (v) => v.VideoId !== this.activeVideo.VideoId
            );
        },
        hasManyVideos() {
            return this.videos.length > 1;
        },
    },
    methods: {
        playVideo(video) {
            this.activeVideo = video;
            this.autoplay = true;
        },
        acceptMarketing() {
            this.consent = false;
            this.showYoutubeVideoList();
        },

        showYoutubeVideoList() {
            axios
                .get(`/api/youtube/getplaylistvideos/?blockId=${this.blockId}`)
                .then((response) => {
                    this.playlistTitle = response.data.playlistTitle;
                    this.playlistUrl = response.data.playlistUrl;
                    this.videos = response.data.videos;
                    this.channel = response.data.channel;
                    this.texts = response.data.texts;

                    // Hide loader
                    this.isLoading = false;

                    // Display error message if no videos is returned
                    if (this.videos.length > 0) {
                        this.error = false;

                        // Set active video to first video, but don't autoplay video.
                        this.activeVideo = this.videos[0];
                    } else {
                        this.error = true;
                    }
                })
                .catch((error) => {
                    this.error = true;
                });
        },
    },
    mounted() {
        if (hasMarketingConsent()) {
            this.showYoutubeVideoList();
        } else {
            this.consent = true;
        }
    },
};
</script>
<style></style>
